import React from 'react';

interface GhostInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const GhostInput = React.forwardRef<HTMLInputElement, GhostInputProps>(
  ({ className = '', ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={`w-full bg-black/20 backdrop-blur-xl border border-white/20 text-white placeholder-white/50 focus:bg-black/75 focus:outline-none focus:ring-2 focus:ring-white/30 focus:border-white/30 rounded-2xl py-2 px-4 shadow-sm transition-all duration-300 ${className}`}
        {...props}
      />
    );
  }
);

GhostInput.displayName = 'GhostInput';
